import apiClient from './apiClient';

export default async function deleteRegistration(id: string) {
  const response = await apiClient.delete(`/reservation/${id}`);
  return response.data;
}
